import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Expandable block inside HistoryAuditSheet — same header, count pill,
 * and border as the Audit Trail / Approval History sections.
 */
export function HistoryAuditSection({
  title,
  icon: Icon,
  count,
  expanded,
  onToggle,
  children,
}: {
  title: string;
  icon: LucideIcon;
  count?: number;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <div className="overflow-hidden rounded-lg border border-border bg-card">
      <div
        className="flex cursor-pointer items-center justify-between px-3 py-2.5 hover:bg-muted"
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <div className="flex items-center gap-2">
          {expanded ? (
            <ChevronDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          ) : (
            <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          )}
          <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">{title}</span>
        </div>
        {count != null && (
          <span className="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
            {count} {count !== 1 ? 'Entries' : 'Entry'}
          </span>
        )}
      </div>
      {expanded && <div className="border-t border-border">{children}</div>}
    </div>
  );
}
